import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  BaseCssConfig,
  BaseCssProperties,
  CarouselActiveSlideAlignment,
  CarouselDataType,
  CarouselScrollBehavior,
  cssToNgStyle,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { EmblaOptionsType } from 'embla-carousel/components/Options';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-generic-carousel-widget',
  templateUrl: './generic-carousel-widget.component.html',
})
export class GenericCarouselWidgetComponent extends BaseComponent {
  public widgetAttributes: UiZoneWidgetAttributeConfig;
  public CarouselDataType = CarouselDataType;
  public numberOfSlides: number;
  public dataType: CarouselDataType;
  public carouselConfig: any;
  public outerCss: string;
  public isWorkflow: boolean;
  public baseCssConfig: BaseCssConfig;
  public carouselSlideConfigs: { [key: string]: string }[] = [];
  public emblaOptions: EmblaOptionsType = {};
  public carouselStyle: { [key: string]: any } = {};
  public carouselSlidesContainerStyle = {};

  constructor(private dataIn: ProviderClass<any>, public configService: ConfigService) {
    super();
    if (this.dataIn != null) {
      this.widgetAttributes = this.dataIn.attri;
    }
  }

  ngOnInit(): void {
    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
    this.applyWidgetStyles();
  }

  private applyWidgetStyles(): void {
    if (!this.widgetAttributes) return;
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.widgetAttributes, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BORDER_V2,
      BaseCssProperties.COLORS_V2,
      BaseCssProperties.BOX_SHADOW,
    ]);

    this.baseCssConfig = this.dataIn.attri?.css_config;
    this.dataType = this.widgetAttributes?.widgetProperties?.['dataType'] || CarouselDataType.NONE;
    this.carouselConfig = this.widgetAttributes?.widgetProperties?.['carouselConfig'];
    this.outerCss = this.widgetAttributes?.outerCss || '';
    this.carouselSlideConfigs = this.widgetAttributes.widgetProperties?.['carouselSlideConfigs'];
    this.buildOptions();
    this.mergedCarouselStyle();
    this.carouselContainerStyle();
  }

  private buildOptions(): void {
    const config = this.carouselConfig ?? {};
    const continuousScroll = config.carouselScrollMode === CarouselScrollBehavior.CONTINUOUS_SCROLL;
    const isLooping = !!config.isInfiniteLoopingEnabled;

    const align: 'start' | 'center' | 'end' =
      config.activeSlidePosition === CarouselActiveSlideAlignment.LEFT_ALIGNED
        ? 'start'
        : config.activeSlidePosition === CarouselActiveSlideAlignment.RIGHT_ALIGNED
        ? 'end'
        : 'center';

    this.emblaOptions = {
      dragFree: !!continuousScroll,
      loop: isLooping,
      align,
      ...(!isLooping ? { containScroll: continuousScroll ? 'keepSnaps' : 'trimSnaps' } : {}),
      watchDrag: true,
      skipSnaps: !continuousScroll,
    };
  }

  public carouselOuterCss() {
    return {
      ...(cssToNgStyle(this.outerCss || '') || {}),
    };
  }

  public mergedCarouselStyle() {
    this.carouselStyle = {
      ...(this.contentStyle || {}),
      ...(this.carouselOuterCss() || {}),
    };
  }

  public carouselContainerStyle() {
    const gapBetweenSlides = this.carouselConfig?.slideSpacingValue + this.carouselConfig?.slideSpacingUnit;

    this.carouselSlidesContainerStyle = {
      gap: gapBetweenSlides,
      ...(this.carouselConfig?.isInfiniteLoopingEnabled ? { 'padding-left': gapBetweenSlides } : {}),
    };
  }
}
